/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { connect } from 'react-redux'
import { compose } from 'recompose'
import { getLoadingStatus } from 'redux-app/selectors/apiData'
import Loading from './Loading'

export default compose<any, any>(
  connect(
    (state, { apiTypes = [], loading = true }) => ({
      isLoading: apiTypes.length ? getLoadingStatus(state, apiTypes).some(e => e) : loading,
    }),
    null,
  ),
)(Loading)
